<template>
  <div class="aboutCompetition" style="background-color:#f8f8f8">
    <childLogo></childLogo>
    <div class="container" style="background-color: #FFF;padding-top: 1px;">
      <div class="navbar-dark">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">关于大赛</span>
          </div>
        </div>
        <div style="font-size: 17px;margin-bottom: 15px;color: #5e5e5e;text-align: center">{{siteName}}</div>
      </div>

      <el-row>
        <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="tabLeft">
          <div class="competition-notice" style="background-color: #F3F8FF;margin-right: 10px;">
            <el-tabs
              v-model="articleId"
              :tab-position="tabPosition"
              class="competition-li"
              @tab-click="tabClick"
            >
              <el-tab-pane
                v-for="(item, index) in list"
                :key="index"
                :label="item.title"
                :name="item.id + ''"
              ></el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
          <div class="competition-notice1">
            <div class="competition-content" v-html="content"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ChildLogo from '@/components/ChildLogo.vue'
import {siteMess} from '@/api/system/index'
export default {
  name: 'AboutCompetition',
  components: {
    ChildLogo: ChildLogo
  },
  data () {
    return {
      siteName: '',
      channelId: undefined,
      articleId: undefined,
      list: [],
      content: undefined,
      tabPosition: 'left'
    }
  },
  beforeMount () {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (mobile) {
      this.tabPosition = 'top'
    }
  },
  created () {
    siteMess(this.siteURL, this.siteId).then(res => {
      this.siteName = res.data.name
    })
    this.getContent()
  },
  methods: {
    getContent () {
      var url = this.siteURL + '/actuator/channel/list?siteId=' + this.siteId + '&url=' + this.$route.path
      this.axios.get(url, {}).then(response => {
        this.channelId = response.data.rows[0].id
        var api = this.siteURL + '/actuator/article/indexList?channelId=' + this.channelId
        this.axios.get(api, {}).then(response => {
          this.list = response.data.rows
          if (this.$route.query.id) {
            this.articleId = String(this.$route.query.id)
          } else {
            this.articleId = response.data.rows[0].id + ''
          }
          this.getArticleData()
        })
      })
    },
    getArticleData () {
      var articleUrl =
        this.siteURL + '/actuator/data/list?articleId=' + this.articleId
      this.axios.get(articleUrl, {}).then(response => {
        this.content = response.data.rows[0].content
      })
    },
    tabClick (tab) {
      console.log('tabName', tab.name)
      this.articleId = tab.name
      this.getArticleData()
    }
  }
}
</script>

<style scoped>
/* 通知公告基础模块 */
.competition {
  min-height: 80px;
}
/* 通知公告竖线样式 */
.competition-line {
  float: left;
  width: 5px;
  height: 50px;
  background-image: linear-gradient(#133c73, #37babd);
  margin-top: 20px;
}
.competition-text {
  margin-left: 10px;
  float: left;
  height: 40px;
  margin-top: 20px;
}
.competition-text-cn {
  font-size: 24px;
}
.competition-text-en {
  font-size: 15px;
  color: #666666;
}
/* 关于大赛内容基础样式 */
.competition-notice {
  margin-top: 10px;
   /* min-height: 536px; */
  color: #666666;
  font-size: 20px;
  background-color: #f8f8f8;
}
/* 关于大赛内容基础样式 */
.competition-notice1 {
  margin-top: 10px;
   min-height: 536px;
  color: #666666;
  font-size: 20px;
  background-color: #f8f8f8;
}
.competition-content {
  padding-top: 20px;
  padding-left: 20px;
  color: #707070;
  font-size: 18px;
  line-height: 36px;
  text-align: left;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0c70fc; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}

@media screen and (max-width: 520px) {
  .tabLeft{
    height: 80px !important;
  }
}
</style>
<style>
/* el table pan样式修改 */
/* 去掉右边实线 */
.aboutCompetition .competition-li .el-tabs__header .el-tabs__nav-wrap::after {
  height: 0% !important;
}
/* 鼠标移入时的颜色改变 */
.aboutCompetition .el-tabs__item:hover {
  color: #0c70fc !important;
}
/* 选中效果文字与背景颜色修改 */
.aboutCompetition .el-tabs__item.is-active {
  color: #fff !important;
  background-color: #0c70fc;
}
/* 使元素充满整个div */
.aboutCompetition .el-tabs__header {
  width: 100% !important;
  height: 100% !important;
}
/* 选项元素样式修改 */
.aboutCompetition .el-tabs__item {
  color: #707070;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  font-weight: 500;
}
/* 选中后 最右边竖线样式修改 */
.aboutCompetition .el-tabs__active-bar {
  /* background-image: linear-gradient(#133c73, #37babd); */
  background-color: #0c70fc;
}
.aboutCompetition .el-tabs--left .el-tabs__active-bar.is-left {
  width: 4px;
}
/* 文字居中 */
.aboutCompetition .el-tabs--left .el-tabs__item.is-left {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/views/AboutCompetition.vue